import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { UserAuthLayout } from "../../components/user/UserAuthLayout";
import { formatApiErrorDetail } from "../../context/UserAuthContext";
import { API_URL } from "../../config";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/users/forgot-password`, { email }, { withCredentials: true });
      setDone(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao enviar email");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <UserAuthLayout
      title="Esqueci-me da password"
      subtitle="Vamos enviar-lhe um link para repor a sua password."
      footer={<><Link to="/login" className="text-amber-400 hover:text-amber-300">← Voltar a entrar</Link></>}
    >
      {done ? (
        <div className="text-sm text-zinc-300 leading-relaxed bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4" data-testid="forgot-done">
          <p className="font-semibold text-emerald-300 mb-1">Verifique a sua caixa de entrada</p>
          <p>Se o email estiver registado, receberá dentro de momentos um link para repor a sua password. O link é válido durante 1 hora.</p>
          <p className="text-xs text-zinc-500 mt-2">Não recebeu? Veja a pasta de spam ou tente novamente em alguns minutos.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email" className="text-zinc-300">Email da conta</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" className="input-dark mt-1.5" autoFocus data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={submitting || !email} className="btn-primary w-full" data-testid="forgot-submit">
            {submitting ? "A enviar..." : "Enviar link de reposição"}
          </Button>
        </form>
      )}
    </UserAuthLayout>
  );
}
